import ApiService from "../../../../services/ApiService";
import { formatToISODateTime } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { CursusStage } from "../../Course.d";
import { CursusStageForm } from "./EditCursusStagePopup.d";

export const cursusStageToForm = (course: CursusStage): CursusStageForm => ({
  content: course.content || "",
  cursus_prefix: course.cursus_prefix,
  default_cadre: course.default_cadre,
  deployment_name: course.deployment_name,
  dt_end: formatToISODateTime(course.dt_end).replace(" ", "T"),
  dt_start: formatToISODateTime(course.dt_start).replace(" ", "T"),
  end_of_formation_document: course.end_of_formation_document || "",
  evaluations: course.evaluations || "",
  format: course.format,
  hours_spent_on_masterclass: course.hours_spent_on_masterclass,
  hours_spent_on_modules: course.hours_spent_on_modules,
  hours_spent_on_project: course.hours_spent_on_project,
  is_disabled: course.is_disabled,
  language: course.language,
  mediator: course.mediator || "",
  objectives: course.objectives || "",
  pedagogy_leader_diplomas: course.pedagogy_leader_diplomas || "",
  pedagogy_leader_references: course.pedagogy_leader_references || "",
  prerequisites: course.prerequisites || "",
  presentation_document_url: course.presentation_document_url || "",
  priority: course.priority,
  total_hours: course.total_hours,
  training_organization: course.training_organization || "",
});

export const getChangedFields = (currentValues: any, initialValues: any) =>
  Object.fromEntries(Object.entries(currentValues).filter(([key, value]) => value !== initialValues[key]));

export const updateCursusStage = (
  cursusStageId: number,
  data: object,
  setIsSaving: Function,
  onSuccess: Function,
  language: string
) => {
  setIsSaving(true);

  ApiService.patch(`cursus/stages/${cursusStageId}`, data)
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error updating cursus stage:", error);
      alert(translate(language, "PAGES.COURSE.MODALS.EDIT_STAGE.ALERTS.ERROR"));
    })
    .finally(() => setIsSaving(false));
};
